import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, input, Signal } from '@angular/core';
import { SelectionButtonComponent } from '@shared/components/challenges/elements/selection-button/selection-button.component';
import { UnselectionButtonComponent } from '@shared/components/challenges/elements/unselection-button/unselection-button.component';
import { WinCardComponent } from '@shared/components/challenges/elements/win-card/win-card.component';
import { CampaignPhase, SubType } from '@shared/constants';
import { FrequencyChallenge } from '@shared/factory';
import { FrequencyChallengeEleventhVariantConfig } from '@shared/models';
import {
  SafePipe,
  TransformUrlToBgPipe,
  VariableReplacementPipe,
} from '@shared/pipes';

import { FrequencyBaseClass } from '../frequency.base.class';

@Component({
  selector: 'b2c-variant11',
  styleUrl: './variant11.component.scss',
  templateUrl: './variant11.component.html',
  imports: [
    SafePipe,
    NgTemplateOutlet,
    WinCardComponent,
    TransformUrlToBgPipe,
    VariableReplacementPipe,
    SelectionButtonComponent,
    UnselectionButtonComponent,
  ],
})
export class Variant11Component extends FrequencyBaseClass {
  challenge = input.required<FrequencyChallenge>();
  config = input.required<FrequencyChallengeEleventhVariantConfig>();

  withShadow = input<boolean>(true);
  isBisCampaign = input<boolean>(false);
  isEventChallenge = input<boolean>(false);
  phase = input<CampaignPhase>(CampaignPhase.CURRENT);

  public readonly SubType: typeof SubType = SubType;

  remainingVisits: Signal<number> = computed(
    () => this.challenge().target - this.challenge().progress
  );

  progressWidth: Signal<string> = computed(() => {
    const totalSegments = this.challenge().target - 1;

    if (totalSegments <= 0) {
      return '0';
    }

    const filledSegments = Math.min(this.challenge().progress, totalSegments);

    return `${(filledSegments / totalSegments) * 100}%`;
  });
}
